import {StringValidacao} from './string';
import {Construtor} from './construtor';

export class TipoTelefone implements Construtor<TipoTelefone> {

  public idTipoTelefone: number;
  public nomeTipoTelefone: string;

  constructor(object?: any) {

    if (object !== undefined) {

      if (object instanceof TipoTelefone) {
        this.copyObject(object);
      } else {
        this.parseFromJson(object);
      }
    }

    return this;
  }

  get obterIdTipoTelefone(): number {
    return this.idTipoTelefone;
  }

  set IdTipoTelefone(idTipoTelefone: any) {
    this.idTipoTelefone = idTipoTelefone;
  }

  get obterNomeTipoTelefone(): string {
    return this.nomeTipoTelefone;
  }

  set NomeTipoTelefone(nomeTipoTelefone) {
    this.nomeTipoTelefone = StringValidacao.copiarStringValida(nomeTipoTelefone);
  }

  copyObject(tipoTelefone: TipoTelefone): void {
    this.idTipoTelefone = tipoTelefone.obterIdTipoTelefone;
    this.nomeTipoTelefone = tipoTelefone.obterNomeTipoTelefone;
  }

  parseFromJson(tipoTelefone: any): void {
    this.IdTipoTelefone = tipoTelefone.idTipoTelefone;
    this.NomeTipoTelefone = tipoTelefone.nomeTipoTelefone;
  }

  getNewInstance(object?: any): TipoTelefone {
    return new TipoTelefone(object);
  }
}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/comum/modelos/tipo-telefone.ts